module.exports = __webpack_public_path__ + "static/img/step3.13f59214.png";